import { rem, stripUnit } from 'polished'
import styled from 'styled-components'
import theme from 'styles/theme'
import { Eyebrow as ThemeEyebrow, Title60 } from 'components/Typography'
import { GatsbyImage } from 'gatsby-plugin-image'

export const Wrapper = styled.section`
  color: ${(props) => props.theme.colors.sagemedium};
  margin: 0;
  padding: 0 20px;
  text-align: center;
`

export const Inner = styled.div`
  margin: 0 auto;
  max-width: 1180px;
`

export const Heading = styled.div`
  margin: 0 38px 40px;

  ${theme.mediaQueries.medium} {
    margin: 0 auto 50px;
    max-width: 780px;
  }
`

export const Eyebrow = styled(ThemeEyebrow)`
  color: ${(props) => props.theme.colors.sagedarkToblack};
  margin-bottom: 10px;
`

export const Headline = styled(Title60)`
  margin: 0;
`

export const Body = styled.div`
  margin-top: 20px;
  text-align: center;

  p,
  ul,
  ol {
    font-size: ${rem(14)};

    ${theme.mediaQueries.medium} {
      font-size: ${rem(16)};
    }
  }
`

export const Grid = styled.div`
  ${theme.mediaQueries.medium} {
    display: flex;
    justify-content: center;
    margin: 0 -10px;
  }
`

export const Promo = styled.article`
  margin-top: 60px;

  ${theme.mediaQueries.medium} {
    flex: 0 1 33.33334%;
    margin-top: 0;
    max-width: 33.33334%;
    padding: 0 10px;
  }

  &:first-child {
    margin-top: 0;
  }
`

export const PromoImg = styled(GatsbyImage)`
  display: block;
  height: calc(100vw - ${stripUnit(theme.space[4]) * 2}em);
  width: 100%;

  ${theme.mediaQueries.medium} {
    height: ${(props) => (props.promosNumber > 3 ? '360px' : '490px')};
  }
`

export const PromoBody = styled.div`
  padding: 20px 20px 0;

  ${theme.mediaQueries.medium} {
    padding: 20px 15px 0;
  }

  .cta {
    display: block;
    margin-top: 30px;
    padding: ${rem(20)};
    width: 100%;
  }
`

export const PromoCopy = styled.div`
  margin-top: 10px;
  text-align: center;

  p,
  ul,
  ol {
    font-size: ${rem(14)};
  }
`
